import { Field } from './field';
import { REQUIRES_COLLECTION } from './constants';

class FieldFactory {
  constructor(template, pillFactory, fieldTierVisibilityFactory) {
    this.template = template;
    this.pillFactory = pillFactory;
    this.fieldTierVisibilityFactory = fieldTierVisibilityFactory;
  }

  make({ name, type, ordinal, collection, required, tierInstances }) {
    const errors = [];

    if (!name) {
      errors.push('MISSING_NAME');
    }

    if (REQUIRES_COLLECTION.includes(type) && (!collection || !collection.length)) {
      errors.push('MISSING_COLLECTION');
    }

    if (errors.length) {
      throw { reasons: errors }
    }

    const newField = this.createFieldFromTemplate(ordinal);

    newField.name = name;
    newField.type = type;
    newField.ordinal = ordinal;
    newField.collection = collection;
    newField.required = required;

    tierInstances.forEach(tierInstance => {
      newField.addTierVisibility(tierInstance);
    });

    newField.enableField();

    return newField;
  }

  createFieldFromTemplate(ordinal) {
    const decoder = document.createElement('textarea');
    decoder.innerHTML = this.template.replace(/idx/g, ordinal);

    const fieldConainter = document.createElement('div');
    fieldConainter.innerHTML = decoder.value;

    return new Field(fieldConainter.firstChild, this.pillFactory, this.fieldTierVisibilityFactory);
  }
}

export { FieldFactory };